export const SIMPLE = 'SIMPLE'
export const VENDOR_MODEL = 'VENDOR_MODEL'
export const COMBINED = 'COMBINED'

export const control_options = [{
    label: 'Упрощенный тип',
    value: SIMPLE,
}, {
    label: 'Произвольный тип',
    value: VENDOR_MODEL,
},{
    label: 'Комбинированный',
    value: COMBINED,
},]